import axios, { AxiosResponse } from 'axios';
import { OnboardingReq } from '@src/types';

export const saveOnboarding = (
  data: OnboardingReq
): Promise<AxiosResponse<{ id: string; url: string }>> => {
  return axios.post('/onboarding/', data);
};

export const validateCoupons = (
  couponCode: string
): Promise<AxiosResponse<{ is_valid: boolean }>> => {
  return axios.get(`/coupons/${couponCode}/validate`);
};
